import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormEntityContext } from '../../config/context/forms'
import FieldWrapper from './FieldWrapper'
import { FormField } from '@/components/ui/form'
import { MinimalTiptapEditor } from '@/components/ui/minimal-tiptap/minimal-tiptap'

interface Props {
  name: string
  customLabel?: React.ReactNode
  customDescription?: React.ReactNode
  className?: string
  uploader?: (file: File) => Promise<string>
}

const RichTextField = ({
  name,
  customLabel,
  customDescription,
  className,
  uploader,
}: Props) => {
  const { t, i18n } = useTranslation()
  const form = useFormContext()
  const { entityType, i18nPrefix } = useContext(FormEntityContext)

  const description =
    customDescription ??
    (i18n.exists(`${i18nPrefix}.${entityType}.${name}.description`)
      ? t(`${i18nPrefix}.${entityType}.${name}.description`)
      : undefined)

  return (
    <div className={`w-full ${className ?? ''}`}>
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => (
          <FieldWrapper
            layout='inline'
            label={
              customLabel ?? t(`${i18nPrefix}.${entityType}.${name}.label`)
            }
            description={description}
          >
            <div>
              <MinimalTiptapEditor
                value={field.value ?? ''}
                onChange={(value) =>
                  field.onChange(typeof value === 'string' ? value : '')
                }
                output='html'
                uploader={uploader}
                className='bg-card'
              />
            </div>
          </FieldWrapper>
        )}
      />
    </div>
  )
}

export default RichTextField
